new Vue({
    el:'#verifyDom',
    data(){
        return{
            code:'',
            ip:'',
            verifyClick:true,
            popup:false,
            info1:'',
            info2:'',
            info3:'',
            infoErr:'',
            flag:true,
            tip:false,
            type:'1',
            typeInfo:'authentic product',
            loadFlag:false,
            warning:false,
            navIndex:0,
            nav:['Device','Cartridge']
        }
    },
    methods:{
        verifyCode(){
            if(this.verifyClick){
                if(this.code != ''){
                    this.verifyClick = false
                    this.tip = true
                    this.getIp()
                }else{
                    showMessage('The Security code cannot be empty','error')
                }
            }
        },
        async send(){ 
            // update store verify --------------------------
            let res = await axios.post(`https://alm.fwdby.com/Api/AppWebApi/AntiQuery?Code=${this.code}&IP=${this.ip}&BrandTypeCode=001`)
            if(res.status == 200){
                this.tip = false
                this.verifyClick = this.popup = true
                this.flag = res.data.Success
                if(res.data.Success){
                    var DataSCode = JSON.parse(res.data.Data)
                    this.type = DataSCode.Type
                    this.info1 = DataSCode.QueryTimes
                    this.info2 = (DataSCode.FirstTime).replace('T', '  ')
                    this.info3 = DataSCode.IndexCode
                    this.warning = DataSCode.Warning
                }else{
                    this.infoErr = 'The security code <div style="color:red;">('+this.code+')</div> you searched does not exist!'
                }
                
            }
            
        },
        async getIp(){
            let res = await axios.get('https://api.ipify.org?format=json')
            if(res.status == 200){
                this.ip = res.data.ip
                this.send()
            }else{
                this.ip = '77.247.125.43'
                this.send()
            }
        },
        async chanceCode(code){
            let res = await axios.post(`https://alm.fwdby.com/Api/AppWebApi/GetAntiCodeByCode?Code=${code}`)
            if(res.status == 200){
                this.verifyClick = false
                this.tip = true
                if(res.data.Success){
                    this.code = res.data.Data
                    this.getIp()
                }else{
                    this.code = code
                    this.getIp()
                }
            }
        }
    },
    async created(){
        // 加载完成后 更新弹窗显示样式
        this.loadFlag = true
        //烟弹防伪码验证
        let YDhref = window.location.href
        if(YDhref.indexOf('?') !== -1 ){
            let query = YDhref.substring(YDhref.indexOf('?') + 6);
            this.chanceCode(query)
            // this.code = query
            // this.verifyClick = false
            // this.tip = true
            // this.getIp()
        }
    }
})


$(function(){
    $('.vit_text span').each(function(index) {
        // 创建新的样式元素
        const style = document.createElement('style');
        // 创建样式规则并设置内容
        style.innerHTML = `.vit_text span:nth-child(${index + 1})::before { content: '${index + 1}.'; }`;
        // 将样式规则插入到文档中的样式表中
        document.head.appendChild(style);
    });
})